import { IFsFileType } from "@r3f-component-data-structure";
import { FsBaseFile } from "./base";

export class FsAudio extends FsBaseFile {
    type: IFsFileType.Audio = IFsFileType.Audio
    protected _objectUrl: string

    constructor(fileId: string, projectId: string, name: string) {
        super(fileId, projectId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/aud.mp3`
        this._objectUrl = url.toString()
    }

    async getUrl() {
        return this.fs.getBlobUrl(this._objectUrl, await this.getBlob())
    }

    async getBlob() {
        return this.fs.getObjectBlob(this._objectUrl)
    }

    async getFilesForBundler() {
        const blob = await this.getBlob()
        return [{
            path: `fs/${this.id}/aud.mp3`,
            bin: new Uint8Array(await blob.arrayBuffer())
        }]
    }
}
